// import logo from './logo.svg';
import './App.css';
import Login from './components/login';
import Signup from './components/signup';
function App() {
  return (
    <div className="App">
      <Login />
      <Signup />
    </div>
  );
}

export default App;
